// embed svp, the following iife is copied from https://github.schibsted.io/svp/web-player
const svpEmbed = () =>
  (function (d, s, id) {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const js: any = d.createElement(s);
    js.id = id;

    js.src =
      'https://cdn.stream.schibsted.media/player/3.47.0/player.next.min.js';
    js.async = true;
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      eval('async () => {}'),
        (js.src = js.src.replace('player.min', 'player.next.min'));
    } catch (a) {
      console.log({ a });
    }
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'svp-player-sdk');

export default svpEmbed;
